import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Fragment } from 'react';
import HighlightedTypography from '../../../components/HighlightedTypography';

const useAccordionStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  label: {
    display: 'grid'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

const StyledAccordion = ({ title, subtitle, detail, onClick, highlight }) => {
  const classes = useAccordionStyles();

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-label="Expand"
        aria-controls="additional-actions1-content"
        id="additional-actions1-header"
      >
        <FormControlLabel
          aria-label="Acknowledge"
          // onClick={event => event.stopPropagation()}
          // onFocus={event => event.stopPropagation()}
          control={
            <IconButton onClick={onClick}>
              <CheckIcon name="radio-buttons" />
            </IconButton>
          }
          label={
            <div className={classes.label}>
              <HighlightedTypography
                noWrap
                className={classes.heading}
                highlight={highlight}
              >
                {title}
              </HighlightedTypography>
              <HighlightedTypography
                noWrap
                className={classes.secondaryHeading}
                highlight={highlight}
              >
                {subtitle}
              </HighlightedTypography>
            </div>
          }
        />
      </AccordionSummary>
      <AccordionDetails>{detail}</AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles({
  root: {
    // height: 264,
    flexGrow: 1
    // maxWidth: 400
  }
});

const PartidaArancelariaHistorialView = ({ onChange, items, highlight }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {items &&
        items.map((item, index) => (
          <Fragment key={index}>
            <StyledAccordion
              title={item.title}
              subtitle={item.subtitle}
              detail={item.detail}
              onClick={() => onChange(item.value, item.title, item.detail)}
              highlight={highlight}
            />
          </Fragment>
        ))}
    </div>
  );
};

export default PartidaArancelariaHistorialView;
